/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptBatchResponse {
    getFixupPrototypeFunction() { return PromptBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<PromptBatchResponse>): PromptBatchResponse {
        let obj = Object.assign(new PromptBatchResponse(), model);
        PromptBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptBatchResponse>): PromptBatchResponse {
        if (!model) return null;
        return PromptBatchResponse.newInstance(<PromptBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptBatchResponse) {
        if (!obj) return;

        models.PromptBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptBatchResponse): boolean {
        Object.setPrototypeOf(obj, PromptBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.Prompt.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.Prompt; };

}
